export const TIER = Object.freeze({
  customer: "Customer",
  msps: "MSP",
  profile: "Profile",
  system: "System",
});

export default {};
